import React from 'react';
import PropTypes from 'prop-types';
import helpers from '../../../helpers/price-helper';

export const Basic = ({ price }) => {

  const formattedPrice = helpers.getUSDollarWithCommas(price);
  return (
    <span className="sui-font-bold sui-text-lg" data-automation-id="pricingScenariosTotalPriceAddedText">
      {formattedPrice}
    </span>
  );
};

Basic.propTypes = {
  price: PropTypes.number,
};

Basic.defaultProps = {
  price: 0,
};

Basic.displayName = 'Basic';
